export default __webpack_public_path__ + "static/media/icons8-folder-48 3.9c8d4eea.svg";